module.exports = __webpack_public_path__ + "static/media/slash.2fc7d71f.svg";